export default "__VITE_ASSET__5eea671e__"